/** H3: "Chrome on Windows" for a signed-in device (sign-in page and the admin member page). */
type Translate = (key: string, values?: Record<string, string | number>) => string;

export function deviceLabel(t: Translate, device: { browser: string | null; os: string | null }) {
  return t("label", {
    browser: device.browser ?? t("unknownBrowser"),
    os: device.os ?? t("unknownSystem"),
  });
}

export function formatDeviceTime(iso: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }).format(
    new Date(iso),
  );
}
